import React from 'react';
import { Button, Tooltip } from '@appd/uik';
import { DemoCodeProps } from './models';
import { DashboardSourceCode } from '../DashboardSourceCode';
import { DashboardJson } from '../../models';

const DemoCode: React.FC<DemoCodeProps> = ({ template }) => {
  return (
    <div>
      <Tooltip value="Copy">
        <Button
          className="p-16"
          type="SECONDARY"
          onClick={() => navigator.clipboard.writeText(JSON.stringify(template, null, 2))}
          icon="Action.Copy"
        >
          Copy JSON Code
        </Button>
      </Tooltip>
      <DashboardSourceCode
        className="mt-2 min-w-full overflow-x-auto"
        dashboard={template as unknown as DashboardJson}
      />
    </div>
  );
};

export default DemoCode;
